import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useGlitchText = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // Update CSS custom properties when language changes
    const updateGlitchTexts = () => {
      const root = document.documentElement;
      
      // Set CSS variables for glitch effects
      root.style.setProperty('--glitch-text', `"${t('contact.title')}"`);
      root.style.setProperty('--glitch-hero-text', '"EXHIBIRTE"');
      root.style.setProperty('--glitch-about-text', `"${t('about.title')}"`);
      root.style.setProperty('--glitch-projects-text', `"${t('projects.title')}"`);
      root.style.setProperty('--glitch-contact-text', `"${t('contact.title')}"`);
      root.style.setProperty('--glitch-skills-text', `"${t('skills.title')}"`);
      root.style.setProperty('--glitch-certifications-text', `"${t('certifications.title')}"`);
      root.style.setProperty('--glitch-news-text', `"${t('news.title')}"`);
      root.style.setProperty('--glitch-works-text', `"${t('nav.projects')}"`);
      root.style.setProperty('--glitch-some-news-text', `"${t('news.title')}"`);
      root.style.setProperty('--glitch-some-works-text', `"${t('projects.title')}"`);
      
      // Menu glitch variables
      root.style.setProperty('--glitch-menu-home-text', `"${t('nav.home')}"`);
      root.style.setProperty('--glitch-menu-about-text', `"${t('nav.about')}"`);
      root.style.setProperty('--glitch-menu-projects-text', `"${t('nav.projects')}"`);
      root.style.setProperty('--glitch-menu-skills-text', `"${t('nav.skills')}"`);
      root.style.setProperty('--glitch-menu-certifications-text', `"${t('nav.certifications')}"`);
      root.style.setProperty('--glitch-menu-contact-text', `"${t('nav.contact')}"`);
    };

    // Update on mount and when language changes
    updateGlitchTexts();
    
    // Listen for language changes
    const handleLanguageChange = () => {
      updateGlitchTexts();
    };

    i18n.on('languageChanged', handleLanguageChange);

    // Cleanup
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [t, i18n]);
};

export default useGlitchText;
